import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetEmailAddressDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface EmailAddressSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  refresh: boolean;
  enableSingleSelect?: boolean;
  selectedKeys?: string[];
  withHistory: boolean;
}

export const emailAddressForGrid = (emailAddress: GetEmailAddressDto) => {
  return {
    key: emailAddress.id,
    values: {
      'emailAddress.emailsTo': emailAddress.emailsTo,
      'emailAddress.emailsDw': emailAddress.emailsDw,
      'emailAddress.comment': emailAddress.comment,
      'emailAddress.emailFrom': emailAddress.emailFrom?.value || '',
    },
    isInactive: !emailAddress.active,
  };
};

export const EmailAddressSearch: React.FC<EmailAddressSearchProps> = props => {
  const { t, tk } = useTranslation('clientLng');

  const columns: GridColumn[] = [
    { header: t(tk.emailAddress.emailsTo), property: 'emailAddress.emailsTo' },
    { header: t(tk.emailAddress.emailsDw), property: 'emailAddress.emailsDw' },
    { header: t(tk.emailAddress.comment), property: 'emailAddress.comment' },
    {
      header: t(tk.emailAddress.emailFrom),
      property: 'emailAddress.emailFrom',
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      refresh={props.refresh}
      initialOrderColumn="emailAddress.emailsTo"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.emailAddress.noEmailAddressForClient)}
      onRowClick={props.onRowClick}
      withHistory={props.withHistory}
      enableSingleSelect={props.enableSingleSelect}
      selectedKeys={props.selectedKeys}
    />
  );
};
